module.exports = __webpack_public_path__ + "static/img/9.0c91eeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/9.png
// module id = IQjG
// module chunks = 0